import { X } from 'lucide-react';
import i18n from '@/settings/i18n';
import { useCollectionPageContext } from '../../hooks/useCollectionPageContext';
import { FilterType } from '../../hooks/types';

const t = i18n.init('collections');

const Header = () => {
  const { clearFilters } = useCollectionPageContext();

  return (
    <div className="flex items-center justify-between">
      <h3 className="text-base">{t`Filter By`}</h3>
      <button
        onClick={clearFilters}
        className="rounded bg-gray-700/5 p-2 text-xs"
      >
        {t`Clear All`}
      </button>
    </div>
  );
};

const Pill = ({ onClick, label }: { onClick: () => void; label: string }) => (
  <button
    className="flex h-6 items-center rounded-full bg-gray-700/5"
    onClick={onClick}
  >
    <div className="px-3">{label}</div>
    <div className="flex h-full  items-center justify-center rounded-r-full bg-gray-700 px-2 text-white">
      <X className="h-3 w-3" />
    </div>
  </button>
);

const SelectedFilters = () => {
  const { filters, selectedFilters, toggleFilter, toggleVariantFilter } =
    useCollectionPageContext();

  const labelFor = (variantId: string, value: string) =>
    filters?.variants
      ?.find((variant) => variant.id === variantId)
      ?.values.find((v) => v.value === value)?.displayValue ?? value;

  if (
    selectedFilters?.categories.length === 0 &&
    selectedFilters?.brands.length === 0 &&
    Object.keys(selectedFilters?.variants ?? {}).length === 0
  ) {
    return null;
  }

  return (
    <div className="border-b border-gray-500 p-4">
      <Header />
      <div className="mt-2 flex flex-wrap items-center gap-2 text-xs">
        {selectedFilters?.categories.map((f) => (
          <Pill
            key={`clear_${f.id}_${f.name}`}
            onClick={() => toggleFilter(FilterType.CATEGORY, f.id, f.name)}
            label={f.name}
          />
        ))}
        {selectedFilters?.brands.map((f) => (
          <Pill
            key={`clear_${f.id}_${f.name}`}
            onClick={() => toggleFilter(FilterType.BRAND, f.id, f.name)}
            label={f.name}
          />
        ))}
        {Object.keys(selectedFilters?.variants ?? {}).map((id) =>
          selectedFilters?.variants[id]?.map((value) => (
            <Pill
              key={`clear_${id}_${value}`}
              onClick={() => toggleVariantFilter(id, value)}
              label={labelFor(id, value)}
            />
          )),
        )}
      </div>
    </div>
  );
};

export default SelectedFilters;
